import { defineStore } from 'pinia';

interface OauthApplication {
  name: string;
  roles?: string[];
}

export interface MetaState {
  userStatus: string[];
  oauthApplications: OauthApplication[];
  recordCount: number;
}

export const useMetaStore = defineStore('meta', {
  state: (): MetaState => ({
    userStatus: [],
    oauthApplications: [],
    recordCount: 0,
  }),
  getters: {
    mediaApp: (state): OauthApplication =>
      state.oauthApplications.find((app) => app.name === 'media') || ({} as OauthApplication),
    mediaRoles(): string[] {
      return this.mediaApp.roles || [];
    },
    roomsApp: (state): OauthApplication =>
      state.oauthApplications.find((app) => app.name === 'rooms') || ({} as OauthApplication),
    roomsRoles(): string[] {
      return this.roomsApp.roles?.filter((role) => role !== 'guardian') || [];
    },
    userManagementApp: (state): OauthApplication =>
      state.oauthApplications.find((app) => app.name === 'user_management') || ({} as OauthApplication),
    userManagementRoles(): string[] {
      return this.userManagementApp.roles || [];
    },
    attendanceProApp: (state): OauthApplication =>
      state.oauthApplications.find((app) => app.name === 'attendance_pro') || ({} as OauthApplication),
    attendanceProRoles(): string[] {
      return this.attendanceProApp.roles || [];
    },
  },
  actions: {
    setMeta(
      payload: {
        userStatuses?: string[];
        oauthApplications?: OauthApplication[];
        recordCount?: number;
      } = {},
    ) {
      this.userStatus = payload.userStatuses ?? [];
      this.oauthApplications = payload.oauthApplications ?? [];
      this.recordCount = payload.recordCount ?? 0;
    },
  },
});
